import { render, staticRenderFns } from "./SellCoins.vue?vue&type=template&id=217dc9d4&"
import script from "./SellCoins.vue?vue&type=script&lang=ts&"
export * from "./SellCoins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports